import { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import assetUrl from 'src/common/utils/assetUrl';
import css from './hero-image.module.scss';
import { isAbsoluteUrl } from '/src/common/components/utils/isAbsoluteUrl';

export default class HeroImage extends Component {
  static propTypes = {
    element: PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      href: PropTypes.string,
    }).isRequired,
    dataTestId: PropTypes.string,
    handleImageClick: PropTypes.func,
  };

  handleClick = () => {
    if (this.props.handleImageClick) {
      this.props.handleImageClick();
    }
  };

  render() {
    const { element, dataTestId } = this.props;

    let imageUrl = `${assetUrl(element.imageUrl)}`;

    if (isAbsoluteUrl(element.imageUrl)) {
      imageUrl = `"${element.imageUrl}"`;
    }
    const imageElement = (
      <div
        key={element.imageUrl}
        className={css.image}
        data-testid="heroImage"
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
    );

    if (element.href) {
      return (
        <Link
          to={element.href}
          data-testid={dataTestId}
          onClick={this.handleClick}
        >
          {imageElement}
        </Link>
      );
    }

    return imageElement;
  }
}
